import Rest from "../../../class/tool/Rest";
import Contract from "./Contract";
import FormBuilder from "../../../class/tool/FormBuilder";
import RegexTools from "../../../class/tool/RegexTools";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import StringTools from "../../../class/tool/StringTools";

class ContractController {
	_rest = new Rest();
	_callback = null;
	_baseURLIndex = "stores/{idStore}/contracts";
	_baseURL = "contracts";
	_baseURLPost = "stores/{idStore}/licenses/{idLicense}/contracts";
	_errors = {
		"license_id": {
			"empty": "Vous devez sélectionner une licence"
		},
		"begin": {
			"empty": "Vous devez sélectionner une date de début",
			"wrong": "La date doit respecter le format suivant : DD/MM/YYYY"
		},
		"end": {
			"wrong": "La date doit respecter le format suivant : DD/MM/YYYY"
		},
		"commitment": {
			"wrong": "La durée d'engagement sélectionnée est invalide"
		},
		"billingType": {
			"wrong": "La période de facturation sélectionnée est invalide"
		},
		"amountExclTax": {
			"empty": "Vous devez saisir un montant mensuel pour le contrat",
			"wrong": "Le montant mensuel du contrat est invalide"
		},
		"vat": {
			"empty": "Vous devez sélectionner une valeur de TVA", "wrong": "La valeur de la TVA saisie est invalide"
		},
		"discountType": {
			"wrong": "Le type de remise saisie est invalide"
		},
		"discountValue": {
			"wrong": "Le montant de la remise saisie est invalide"
		},
		"discountDuration": {
			"wrong": "Le nombre de mois saisie est invalide"
		},
		"contract_file": {
			"empty": "Vous devez sélection un fichier",
			"wrong": "Le fichier est invalide, format accepté : PDF"
		},
		"terminated_on": {
			"empty": "Vous devez sélectionner une date de résiliation",
			"wrong": "La date doit respecter le format suivant : DD/MM/YYYY"
		},
		"terminationReason": {
			"empty": "Vous devez saisir une raison",
			"wrong": "La raison saisie est incorrecte"
		},
	};
	_commitments = [{
			value: "12", id: 12
		},
		{
			value: "24", id: 24
		},
			{
			value: "36", id: 36
		},
			{
			value: "48", id: 48
		}
	];
	_billingTypesFull = [
		{
			value: "MONTH", id: 1
		},
		{
			value: "YEAR", id: 2
		},
		{
			value: "TOTAL", id: 3
		}
	];
	_billingTypesLimited = [
		{
			value: "YEAR", id: 2
		},
		{
			value: "TOTAL", id: 3
		}
	];
	_discountTypes = [
		{
			value: "", id: 0
		},
		{
			value: "DEVISE", id: 1
		},
		{
			value: "PERCENT", id: 2
		},
		{
			value: "OFFERED", id: 3
		}
	];
	_vats = [
		{
			value: "20", id: 20
		},
		{
			value: "0", id: 0
		}
	];
	static _commitmentNames = {
		"12": "12 mois", "24": "24 mois", "36": "36 mois", "48": "48 mois"
	};
	static _billingTypeNames = {
		"MONTH": "Mensuelle", "YEAR": "Annuelle", "TOTAL": "Totalité"
	};
	static _discountTypeNames = {
		"": "Aucune",
		"DEVISE": "Euros",
		"PERCENT": "Pourcent",
		"OFFERED": "Offert"
	};
	static _vatNames = {
		"20": "20 %",
		"0": "0 %"
	};
    static _states = {
        "WAITING": "A compléter",
        "INCOMPLETE": "Incomplet",
        "READY": "Prêt",
        "ACTIVE": "Actif",
        "STANDBY": "A reconduire",
        "TERMINATING": "Résiliation..",
        "TERMINATED": "Résilié"
    };

	// perform

	setFormValues(object, setValues, formNew = false, datas) {
		dayjs.locale('fr');

		if (formNew) {
			let license = datas.store.setup.licenses.find(_ => !_.has_contract);

			setValues(prev => ({
				...prev,
				license_id: license !== undefined ? license.id : null,
				begin: dayjs().format("DD/MM/YYYY"),
				commitment: this._commitments[0].value,
				billingType: datas.store.partnership_id === 1 ? this._billingTypesFull[0].value : this._billingTypesLimited[0].value,
				amountExclTax: 69.90,
				vat: this._vats[0].value,
				discountType: null,
				discountValue: "",
				discountDuration: ""
			}));
		}
		else {
			setValues(prev => ({
				...prev,
				begin: dayjs(object.begin).format("DD/MM/YYYY"),
				commitment: object.commitment,
				billingType: object.billingType,
				amountExclTax: object.amountExclTaxUndiscounted,
				vat: parseInt(object.vat).toString(),
				discountType: object.discountType,
				discountValue: object.discountValue,
				discountDuration: object.discountDuration
			}));
		}
	}
	setFileContractValues(object, setValues) {
		setValues(prev => ({
			...prev,
			contract_file: object.contract_file
		}));
	}
	setTerminateContractValues(object, setValues) {
		setValues(prev => ({
			...prev,
			terminationReason: "",
			terminated_on: dayjs().format("DD/MM/YYYY")
		}));
	}
	setFormRows(setRows, formNew = false, datas) {
		let rows;

		if (formNew) {
			let licenses = [
				{
					value: "Sélectionner une licence",
					id: null
				},
				{
					value: "----------",
					id: null
				}
			];
			let filter = datas.store.setup.licenses.filter(_ => !_.has_contract);

			for (let i in filter) {
				licenses.push({
					value: filter[i].number + " (" + filter[i].name + ")", id: filter[i].id
				});
			}

			rows = [
				{
					label: "Licence",
					attribute: "license_id",
					inputType: "select",
					returnType: "int",
					list: licenses,
					dictionary: null,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Début du contrat",
					attribute: "begin",
					inputType: "date",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "DD/MM/YYYY",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Engagement",
					attribute: "commitment",
					inputType: "select",
					returnType: "string",
					list: this._commitments,
					dictionary: ContractController._commitmentNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Facturation",
					attribute: "billingType",
					inputType: "select",
					returnType: "string",
					list: datas.store.partnership_id === 1 ? this._billingTypesFull : this._billingTypesLimited,
					dictionary: ContractController._billingTypeNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Montant H.T.",
					attribute: "amountExclTax",
					inputType: "text",
					returnType: "float",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "69,90",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "TVA",
					attribute: "vat",
					inputType: "select",
					returnType: "string",
					list: this._vats,
					dictionary: ContractController._vatNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Type de remise",
					attribute: "discountType",
					inputType: "select",
					returnType: "string",
					list: this._discountTypes,
					dictionary: ContractController._discountTypeNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: false,
					checkData: null
				},
				{
					label: "Montant de la remise",
					attribute: "discountValue",
					inputType: "text",
					returnType: "float",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "",
					autoComplete: "off",
					needed: false,
					checkData: null
				},
				{
					label: "Durée de la remise",
					attribute: "discountDuration",
					inputType: "text",
					returnType: "float",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "",
					autoComplete: "off",
					additional: "Durée de la remise en nombre de mois",
					needed: false,
					checkData: null
				}
			];
		}
		else {
			rows = [
				{
					label: "Début du contrat",
					attribute: "begin",
					inputType: "date",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "DD/MM/YYYY",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Engagement",
					attribute: "commitment",
					inputType: "select",
					returnType: "string",
					list: this._commitments,
					dictionary: ContractController._commitmentNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Facturation",
					attribute: "billingType",
					inputType: "select",
					returnType: "string",
					list: datas.store.partnership_id === 1 ? this._billingTypesFull : this._billingTypesLimited,
					dictionary: ContractController._billingTypeNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Montant H.T.",
					attribute: "amountExclTax",
					inputType: "text",
					returnType: "float",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "69,90",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "TVA",
					attribute: "vat",
					inputType: "select",
					returnType: "string",
					list: this._vats,
					dictionary: ContractController._vatNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: true,
					checkData: null
				},
				{
					label: "Type de remise",
					attribute: "discountType",
					inputType: "select",
					returnType: "string",
					list: this._discountTypes,
					dictionary: ContractController._discountTypeNames,
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					classnameNoInput: "",
					needed: false,
					checkData: null
				},
				{
					label: "Montant de la remise",
					attribute: "discountValue",
					inputType: "text",
					returnType: "float",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "",
					autoComplete: "off",
					needed: false,
					checkData: null
				},
				{
					label: "Durée de la remise",
					attribute: "discountDuration",
					inputType: "text",
					returnType: "float",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "",
					autoComplete: "off",
					additional: "Durée de la remise en nombre de mois",
					needed: false,
					checkData: null
				}
			];
		}

		setRows(rows);
	}
	setFileContractFormRows(setRows) {
		let rows = [
			{
				attribute: "contract_file",
				inputType: "file",
				returnType: "string",
				classnameWrapper: null,
				classnameLabel: null,
				classnameInput: "",
				extensions: ["pdf"],
				needed: true,
				checkData: null
			}
		];

		setRows(rows);
	}
	setTerminateContractFormRows(setRows) {
		let rows = [
			{
				label: "Début du résiliation",
				attribute: "terminated_on",
				inputType: "date",
				returnType: "string",
				classnameWrapper: null,
				classnameLabel: null,
				classnameInput: "",
				placeholder: "DD/MM/YYYY",
				autoComplete: "off",
				needed: true,
				checkData: null
			},
			{
				label: "Motif de résiliation",
				attribute: "terminationReason",
				inputType: "richText",
				returnType: "string",
				classnameWrapper: null,
				classnameLabel: null,
				classnameInput: "",
				placeholder: "Motif ...",
				needed: true,
				checkData: null
			}
		];

		setRows(rows);
	}
	returnPostDatas(datas) {
		let datasToPost = {};
		let needed = ["license_id", "begin", "end", "commitment", "billingType", "amountExclTax", "vat"];
		let optionals = ["end", "discountType", "discountValue", "discountDuration"];

		for (let i in needed) {
			datasToPost[needed[i]] = datas[needed[i]];
		}

		for (let i in optionals) {
			if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

			switch (typeof datas[optionals[i]]) {
				case "string":
					if (datas[optionals[i]].length === 0) continue;
					break;
				default:
					break;
			}

			datasToPost[optionals[i]] = datas[optionals[i]];
		}

		return datasToPost;
	}
	returnPutDatas(datas) {
		let datasToPost = {};
		let needed = ["begin", "commitment", "billingType", "amountExclTax", "vat"];
		let optionals = ["end", "discountType", "discountValue", "discountDuration"];

		for (let i in needed) {
			datasToPost[needed[i]] = datas[needed[i]];
		}

		for (let i in optionals) {
			if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

			switch (typeof datas[optionals[i]]) {
				case "string":
					if (datas[optionals[i]].length === 0) continue;
					break;
				default:
					break;
			}

			datasToPost[optionals[i]] = datas[optionals[i]];
		}

		return datasToPost;
	}
	returnFileContractDatas(datas) {
		let datasToPost = {};
		let needed = ["contract_file"];
		let optionals = [];

		for (let i in needed) {
			datasToPost[needed[i]] = datas[needed[i]];
		}

		for (let i in optionals) {
			if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

			switch (typeof datas[optionals[i]]) {
				case "string":
					if (datas[optionals[i]].length === 0) continue;
					break;
				default:
					break;
			}

			datasToPost[optionals[i]] = datas[optionals[i]];
		}

		return datasToPost;
	}
	returnTerminateContractDatas(datas) {
		let datasToPost = {};
		let needed = ["terminated_on", "terminationReason"];
		let optionals = [];

		for (let i in needed) {
			datasToPost[needed[i]] = datas[needed[i]];
		}

		for (let i in optionals) {
			if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

			switch (typeof datas[optionals[i]]) {
				case "string":
					if (datas[optionals[i]].length === 0) continue;
					break;
				default:
					break;
			}

			datasToPost[optionals[i]] = datas[optionals[i]];
		}

		return datasToPost;
	}
	returnUpdatesFromCompare(object, datas, compare = true) {
		return FormBuilder.returnUpdates(object, datas, compare);
	}

	hasValidMinimumDatas(values, type, subType = null) {
		let datas;
		let resultData;

		switch (type) {
			case "newContract":
				datas = this.returnPostDatas(values);

				for (let key in datas) {
					resultData = this.checkDataToPost(key, datas[key]);

					if (!resultData.result) return false;
				}

				// additional check
				if(datas.discountType !== undefined && datas.discountType.length > 0) {
					let resultDiscountValue = null;
					let resultDiscountDuration = null;

					if (datas.discountValue !== undefined)
						resultDiscountValue = this.controlDiscountValue(datas.discountValue);

					if (datas.discountDuration !== undefined)
						resultDiscountDuration = this.controlDiscountDuration(datas.discountDuration);

					if (datas.discountValue === undefined || datas.discountValue === null || datas.discountValue.length === 0 || resultDiscountValue === null || !resultDiscountValue.result) {
						return false;
					}

					if (datas.discountDuration !== undefined && datas.discountDuration !== null && datas.discountDuration.length > 0) {
						if (resultDiscountDuration !== null && !resultDiscountDuration.result) {
							return false;
						}
					}
				}

				return true;
			case "updateContract":
				datas = this.returnPutDatas(values);

				for (let key in datas) {
					resultData = this.checkDataToPost(key, datas[key]);

					if (!resultData.result)  {
						return false;
					}
				}

				// additional check
				if(datas.discountType !== undefined && datas.discountType.length > 0) {
					let resultDiscountValue = null;
					let resultDiscountDuration = null;

					if (datas.discountValue !== undefined)
						resultDiscountValue = this.controlDiscountValue(datas.discountValue);

					if (datas.discountDuration !== undefined)
						resultDiscountDuration = this.controlDiscountDuration(datas.discountDuration);

					if (datas.discountValue === undefined || datas.discountValue === null || datas.discountValue.length === 0 || resultDiscountValue === null || !resultDiscountValue.result) {
						return false;
					}

					if (datas.discountDuration !== undefined && datas.discountDuration !== null && datas.discountDuration.length > 0) {
						if (resultDiscountDuration !== null && !resultDiscountDuration.result) {
							return false;
						}
					}
				}

				return true;
			case "fileContract":
				datas = this.returnFileContractDatas(values);

				for (let key in datas) {
					resultData = this.checkDataToPost(key, datas[key]);

					if (!resultData.result) return false;
				}

				return true;
			case "terminateContract":
				datas = this.returnTerminateContractDatas(values);

				for (let key in datas) {
					resultData = this.checkDataToPost(key, datas[key]);

					if (!resultData.result) return false;
				}

				return true;
			default:
				return false;
		}
	}
	okToSend(datas, setEvent) {
		if (datas.discountType !== undefined && datas.discountType.length > 0) {
			switch (datas.discountType) {
				case "DEVISE":
					if (datas.discountValue === undefined || datas.discountValue === null || datas.discountValue.length === 0) {
						setEvent({
							type: "error",
							text: "Vous devez saisir le montant de la remise"
						});
						return false;
					}

					if (datas.discountValue >= datas.amountExclTax) {
						setEvent({
							type: "error",
							text: "Le montant de la remise doit être inférieur au montant du contrat"
						});
						return false;
					}

					break;
				case "PERCENT":
					if (datas.discountValue === undefined || datas.discountValue === null || datas.discountValue.length === 0) {
						setEvent({
							type: "error",
							text: "Vous devez saisir le montant de la remise"
						});
						return false;
					}

					if (datas.discountValue <= 0 || datas.discountValue >= 100) {
						setEvent({
							type: "error",
							text: "Le montant de la remise doit être supérieur à 0 et inférieur à 100"
						});
						return false;
					}

					break;
				default: break;
			}
		}

		if (datas.discountDuration !== undefined && datas.discountDuration.length > 0) {
			if (parseInt(datas.discountDuration) >= parseInt(datas.commitment)) {
				setEvent({
					type: "error",
					text: "La durée de la remise doit être inférieur au nombre de mois d'engagement"
				});
				return false;
			}
		}

		return true;
	}
	checkDataToPost(attribute, value) {
		switch (attribute) {
			case "license_id":
				return this.controlLicenseId(value);
			case "begin":
				return this.controlBegin(value);
			case "end":
				return this.controlEnd(value);
			case "commitment":
				return this.controlCommitment(value);
			case "billingType":
				return this.controlBillingType(value);
			case "amountExclTax":
				return this.controlAmountExclTax(value);
			case "vat":
				return this.controlVat(value);
			case "discountType":
				return this.controlDiscountType(value);
			case "discountValue":
				return this.controlDiscountValue(value);
			case "discountDuration":
				return this.controlDiscountDuration(value);
			case "contract_file":
				return this.controlContractFile(value);
			case "terminated_on":
				return this.controlTerminatedOn(value);
			case "terminationReason":
				return this.controlTerminationReason(value);
			default:
				console.log("Unknown attribute", attribute);
				return {
					result: false, error: "Unknown attribute"
				};
		}
	}
	controlLicenseId(value) {
		let regex = /^[0-9]{1,}$/;

		if (!regex.test(value)) {
			return {
				result: false, error: this._errors["license_id"]["empty"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlBegin(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false, error: this._errors["begin"]["empty"]
			};
		}

		let regex = RegexTools.getRegex("date");

		if (!regex.test(value)) {
			return {
				result: false, error: this._errors["begin"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlEnd(value) {
		if (value !== undefined && value !== null && value.length > 0) {
			let regex = /^[a-zA-Z0-9\-+'.,#&\s]{2,30}$/i;

			if (!regex.test(value)) {
				return {
					result: false, error: this._errors["end"]["wrong"]
				};
			}
		}

		return {
			result: true, error: null
		};
	}
	controlCommitment(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false, error: this._errors["commitment"]["empty"]
			};
		}

		let regex = ["12","24","36","48"];
		if (!regex.includes(value)) {
			return {
				result: false, error: this._errors["commitment"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlBillingType(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false, error: this._errors["billingType"]["wrong"]
			};
		}

		let regex = ["MONTH","YEAR","TOTAL"];
		if (!regex.includes(value)) {
			return {
				result: false, error: this._errors["billingType"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlAmountExclTax(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false, error: this._errors["amountExclTax"]["empty"]
			};
		}

		let regex = RegexTools.getRegex("amount");

		if (!regex.test(value)) {
			return {
				result: false, error: this._errors["amountExclTax"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlVat(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false, error: this._errors["vat"]["empty"]
			};
		}

		let regex = ["0","20"];
		if (!regex.includes(value)) {
			return {
				result: false, error: this._errors["vat"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlDiscountType(value) {
		if (value === undefined || value === null || value.length === 0) {
			return null;
		}

		let regex = ["DEVISE","PERCENT","OFFERED"];
		if (!regex.includes(value)) {
			return {
				result: false, error: this._errors["discountType"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlDiscountValue(value) {
		if (value === undefined || value === null || value.length === 0) {
			return null;
		}

		let regex = RegexTools.getRegex("amount");

		if (!regex.test(value)) {
			return {
				result: false, error: this._errors["amountExclTax"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlDiscountDuration(value) {
		if (value === undefined || value === null || value.length === 0) {
			return null;
		}

		let regex = RegexTools.getRegex("integer");

		if (!regex.test(value)) {
			return {
				result: false, error: this._errors["discountDuration"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlContractFile(value) {
		if (value === undefined || value === null || value.name === undefined) {
			return {
				result: false, error: this._errors["contract_file"]["empty"]
			};
		}

		// check extension : PDF
		if (!["pdf"].includes(StringTools.getExtension(value.name))) {
			return {
				result: false, error: this._errors["contract_file"]["wrong"]
			};
        }

		return {
			result: true, error: null
		};
	}
	controlTerminatedOn(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false, error: this._errors["terminated_on"]["empty"]
			};
		}

		let regex = RegexTools.getRegex("date");

		if (!regex.test(value)) {
			return {
				result: false, error: this._errors["terminated_on"]["wrong"]
			};
		}

		return {
			result: true, error: null
		};
	}
	controlTerminationReason(value) {
		if (value === undefined || value === null || value.length === 0) {
			return {
				result: false, error: this._errors["terminationReason"]["empty"]
			};
		}

		return {
			result: true, error: null
		};
	}

	// Controllers

	index(idStore) {
		this._rest._contentType = "application/json";
		this._rest.sendQuery("GET", "/" + this._baseURLIndex.replace("{idStore}", idStore), {}, this.handleIndex);
	}
	handleIndex = (response, error, status) => {
		let listObjects = [];

		if (response.data !== undefined) {
			const data = response.data;

			for (let item in data) listObjects.push(new Contract(data[item]));
		}

		this._callback(listObjects, error, status);
	};
	stateNextContracts(idStore) {
		this._rest._contentType = "application/json";
		this._rest.sendQuery("GET", "/" + this._baseURLIndex.replace("{idStore}", idStore) + "/statenextcontracts", {}, this.handleStateNextContracts);
	}
	handleStateNextContracts = (response, error, status) => {
		this._callback(response, error, status);
	};
	show(id) {
		this._rest._contentType = "application/json";
		this._rest.sendQuery("GET", "/" + this._baseURL + "/" + id, {}, this.handleShow);
	}
	handleShow = (response, error, status) => {
		const object = !error ? new Contract(response.data) : null;
		this._callback(object, error, status);
	};
	post(idStore, idLicense, datas) {
		this._rest._contentType = "application/json";
		this._rest.sendQuery("POST", "/" + this._baseURLPost.replace("{idStore}", idStore).replace("{idLicense}", idLicense), datas, this.handlePost);
	}
	handlePost = (response, error, status) => {
		this._callback(response, error, status);
	};
	put(object, datas) {
		this._rest._contentType = "application/json";
		this._rest.sendQuery("PUT", "/" + this._baseURL + "/" + object.id, datas, this.handlePut);
	}
	handlePut = (response, error, status) => {
		this._callback(response, error, status);
	};
	delete(object) {
		this._rest._contentType = "application/json";
		this._rest.sendQuery("DELETE", "/" + this._baseURL + "/" + object.id, {}, this.handleDelete);
	}
	handleDelete = (response, error, status) => {
		this._callback(response, error, status);
	};
	postFile(object, datas) {
		this._rest._contentType = "multipart/form-data";
		this._rest.sendQuery("POST", "/" + this._baseURL + "/" + object.id + "/file", datas, this.handlePostFile);
	}
	handlePostFile = (response, error, status) => {
		this._callback(response, error, status);
	};

	// Static

	static calculateAmount(amount, discountType, discountValue, secondaryContract) {
		let amountUndiscounted = amount;
		let discountAmount = 0;

		if (secondaryContract) {
			amount = Math.fround(amount * .5);
		}

		let amountOrigin = amount;

		if (discountType !== null && discountValue !== null) {
			switch (discountType) {
				case "DEVISE":
					discountAmount = discountValue;
					amount = Math.fround(amount - discountValue);
					break;
				case "PERCENT":
					discountAmount = Math.fround(amount * (discountValue / 100));
					amount = Math.fround(amount - discountAmount);
					break;
				case "OFFERED":
					amount = 0;
					break;
			}
		}

		return {
			amountUndiscounted,
			amount,
			discountAmount,
			amountOrigin
		};
	}
}

export default ContractController;
